/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-string-refs */
/* eslint-disable jsx-a11y/no-autofocus */

import React from 'react';
import pt from 'prop-types';
import Label from './label';
import JsonEditor from 'components/json-editor';

import './input-json-editor.scss';

function getJSON(value) {
  try {
    if (typeof value === 'string') {
      return JSON.parse(value);
    } else if (value && typeof value === 'object') {
      return value;
    } else {
      return {};
    }
  } catch {
    // noop
  }
}

export default class InputEditor extends React.Component {
  static propTypes = {
    id: pt.string,
    label: pt.string,
    help: pt.string,
    value: pt.oneOfType([pt.object, pt.array, pt.string]),
    defaultValue: pt.oneOfType([pt.object, pt.array, pt.string]),
    disabled: pt.bool,
    onChange: pt.func,
    onKeyDown: pt.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: getJSON(props.defaultValue || props.value),
      defaultValue: props.defaultValue,
      valid: true,
      error: null,
    };
    this.changeTimeout = null;
  }

  static getDerivedStateFromProps(props, state) {
    if (props.value !== state.value) {
      return {
        value: getJSON(props.value),
        defaultValue: props.defaultValue,
      };
    }

    if (props.defaultValue !== state.defaultValue) {
      return {
        value: getJSON(props.defaultValue),
        defaultValue: props.defaultValue,
      };
    }

    return null;
  }

  onChange = (value) => {
    this.setState({ value });
    const event = new Event('change', { bubbles: true });
    this.props.onChange(event, value);
  };

  onValidate = (valid, error) => {
    this.setState({ valid, error });
  };

  value() {
    return this.state.value;
  }

  validate() {
    return this.state.valid;
  }

  render() {
    let { id, label, help, onKeyDown, disabled } = this.props;

    return (
      <span className="form-json-editor">
        <Label label={label} help={help} htmlFor={id} />
        <input
          type="text"
          ref="input"
          style={{ visibility: 'hidden', position: 'absolute' }}
        />
        <span className="form-field-input" onKeyDown={onKeyDown}>
          <JsonEditor
            id={id}
            onChange={this.onChange}
            onValidate={this.onValidate}
            value={this.state.value}
            autoFocus={!disabled}
            readOnly={disabled}
          />
        </span>
      </span>
    );
  }
}
